import React, { PropsWithChildren, useContext } from "react"
import { CustomFieldContext } from "../contexts/CustomConfigContext"
import { useTranslationOrUndefined } from "../i18n"

export type TextEditProps = PropsWithChildren<{
    placeholder?: string
    id?: string
    value?: string
    onChange?: (value: string) => void
    readonly?: boolean
    multiline?: boolean
    type?: string
}>

export function TextEdit(props: TextEditProps) {
    const tNullSafe = useTranslationOrUndefined()
    const customFieldContext = useContext(CustomFieldContext)

    const readonly = customFieldContext?.disabled ?? props.readonly ?? false
    const placeholder = tNullSafe(customFieldContext?.placeholder) ?? props.placeholder ?? ""
    // const defaultValue = customFieldContext?.defaultValue ?? props.

    const onChange = (event: any) => {
        props.onChange?.(event.target.value)
    }

    const onBlur = () => {
        const value = props.value
        const trimmed = value?.trim() || ""
        if (trimmed !== value) {
            // setValue(trimmed)
            props.onChange?.(trimmed)
        }
    }

    return props.multiline ? (
        <textarea
            id={props.id}
            className="form-control"
            rows={3}
            placeholder={placeholder}
            value={props.value}
            onChange={onChange}
            disabled={readonly}
            onBlur={onBlur}
        />
    ) : (
        <input
            id={props.id}
            type={props.type && props.type.trim() != "" ? props.type : "text"}
            className="form-control"
            placeholder={placeholder}
            value={props.value}
            onChange={onChange}
            disabled={readonly}
            onBlur={onBlur}
            pattern={customFieldContext?.pattern}
        />
    )
}
